import { ReactNode, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import t from "@/lang/lang";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useOmniOfferDeleteMutation } from "@/services/backend/omni/offer/api/offer-api";

export function OfferDeleteDialog({
  offerId,
  onDeleted,
  trigger,
}: {
  offerId: string;
  onDeleted?: () => void;
  trigger?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [deleteOffer, { isLoading, error, reset }] =
    useOmniOfferDeleteMutation();

  const onConfirm = () => {
    if (isLoading) {
      return;
    }
    deleteOffer({ id: offerId })
      .unwrap()
      .then(() => {
        toast.success(t("Angebot gelöscht"));
        reset();
        setOpen(false);
        onDeleted?.();
      })
      .catch(() => {
        // The error is shown by the RTKQueryErrorAlert.
      });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger || (
        <CommonDialogTrigger icon={Trash2} label="" variant="destructive" />
      )}
      <DialogContent>
        <CommonDialogHeader
          title={t("Angebot wirklich löschen?")}
          description={t(
            "Das Angebot wird mit allen Positionen gelöscht. Dies kann nicht rückgängig gemacht werden.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={onConfirm}
          actionLabel={t("Löschen")}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
